import routes from '@constants/routes.json';

const currentYear = new Date().getFullYear();

type ScalarValue = string | number | boolean | null | undefined | Date | string[];
interface DataRecord {
  [key: string]: ScalarValue | DataRecord | DataRecord[];
}
type PayloadValue = ScalarValue | DataRecord | DataRecord[];

export const prepareYearsArray = (range = 10): OptionType[] => {
  const arr = [];
  for (let i = 0; i <= range; i += 1) {
    arr.push({ name: (currentYear + i).toString() });
    arr.push({ name: (currentYear - i).toString() });
  }

  return arr.sort((a, b) => Number(a.name) - Number(b.name));
};

export const hasNullValue = (array: DataRecord[]) => array.some((item) => Object.values(item).some((v) => v === ''));

export const hasAllNullValues = (item: DataRecord) => !Object.values(item).some((v) => v && v !== '');

export const getFullName: (user: User) => string = (user) => `${user.firstName} ${user.lastName}`;

export const prepareLink: (type: 'employer' | 'offer', slug: string, id: number) => string = (type, slug, id) => {
  switch (type) {
    case 'employer':
      return `${routes.employer.source}/${slug || id}`;
    case 'offer':
      return `${routes.offers.source}/${slug || id}`;
    default:
      return '/#';
  }
};

export const isObjectEmpty: (o: DataRecord) => boolean = (object) => {
  const newObject = { ...object };
  const keys = Object.keys(newObject);

  if (!keys.length) {
    return true;
  }

  keys.forEach((key) => {
    if (!newObject[key]) {
      delete newObject[key];
    }
  });

  return !!Object.keys(newObject).length;
};

export const getKeyByValue: (object: Record<string, string>, value: string | string[]) => string = (object, value) => {
  const indexOfS = Object.values(object).indexOf(value as string);

  const key = Object.keys(object)[indexOfS];

  return key as string;
};

export const enumToArray = (
  ENUM: Record<string, string>,
  t: (key: string, options?: Record<string, string>) => string,
) => Object.keys(ENUM).map((key) => ({ label: t(ENUM[key] as string, { ns: 'common' }), value: key }));

export const preparePayloadData: (object: Record<string, PayloadValue>) => Record<string, PayloadValue> = (object) => {
  const newObject: Record<string, PayloadValue> = {};
  Object.keys(object).forEach((key) => {
    const value = object[key];
    if (value !== null && value !== undefined) {
      if (value === 'true' || value === 'false') {
        newObject[key] = JSON.parse(value) as boolean;
      } else {
        newObject[key] = value;
      }
    }
  });
  return newObject;
};
